<template>
  <div class="loading-icon">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
.loading-icon {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  &.--primary .bar {
    background: var(--nxt-color-primary);
  }

  &.--secondary .bar {
    background: var(--nxt-color-secondary);
  }

  .bar {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: var(--nxt-color-secondary);
    animation: loading-icon-animation 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    @include breakpoint(tablet) {
      background: var(--nxt-color-white);
    }
    &:nth-child(1) {
      left: 8px;
      animation-delay: -0.24s;
    }
    &:nth-child(2) {
      left: 32px;
      animation-delay: -0.12s;
    }
    &:nth-child(3) {
      left: 56px;
      animation-delay: 0;
    }
  }
}

@keyframes loading-icon-animation {
  0% {
    top: 8px;
    height: 64px;
  }
  50%, 100% {
    top: 24px;
    height: 32px;
  }
}

</style>
